import { ScreenWidthMinLarge, ScreenWidthMinMedium, ScreenWidthMinSmall, ScreenWidthMinXLarge } from '@fluentui/react';
export var CoherencePanelSize;
(function (CoherencePanelSize) {
    CoherencePanelSize["small"] = "304px";
    CoherencePanelSize["medium"] = "600px";
    CoherencePanelSize["large"] = "1160px";
})(CoherencePanelSize || (CoherencePanelSize = {}));
export var panelMargin = {
    xs: '16px',
    sm: '32px',
    md: '48px',
    lg: '64px'
};
export var getResponsivePanelWidth = function (size, _isFooterInBody) {
    var _a, _b, _c;
    var width;
    switch (size) {
        case CoherencePanelSize.medium:
            width = (_a = {},
                _a['@media (min-width: 648px)'] = {
                    width: _isFooterInBody ? '100%' : CoherencePanelSize.medium
                },
                _a["@media (min-width: " + ScreenWidthMinSmall + "px) and (max-width: 647px)"] = {
                    width: _isFooterInBody ? '100%' : 'calc(100% - 48px)',
                    minWidth: '272px'
                },
                _a);
            break;
        case CoherencePanelSize.large:
            width = (_b = {},
                _b['@media (min-width: 1208px)'] = {
                    width: _isFooterInBody ? '100%' : CoherencePanelSize.large
                },
                _b["@media (min-width: " + ScreenWidthMinSmall + "px) and (max-width: 1207px)"] = {
                    width: _isFooterInBody ? '100%' : 'calc(100% - 48px)',
                    minWidth: '272px'
                },
                _b);
            break;
        case CoherencePanelSize.small:
        default:
            width = (_c = {},
                _c['@media (min-width: 352px)'] = {
                    width: _isFooterInBody ? '100%' : CoherencePanelSize.small
                },
                _c["@media (min-width: " + ScreenWidthMinSmall + "px) and (max-width: 351px)"] = {
                    width: _isFooterInBody ? '100%' : 'calc(100% - 48px)',
                    minWidth: '272px'
                },
                _c);
            break;
    }
    return width;
};
export var getResponsivePanelMargin = function (size, _isFooterInBody) {
    var _a, _b, _c;
    var margins;
    switch (size) {
        case CoherencePanelSize.medium:
            margins = (_a = {},
                _a["@media (min-width: " + ScreenWidthMinLarge + "px)"] = {
                    marginLeft: _isFooterInBody ? '0px' : panelMargin.md,
                    marginRight: _isFooterInBody ? '0px' : panelMargin.md
                },
                _a["@media (min-width: " + ScreenWidthMinMedium + "px) and (max-width: " + (ScreenWidthMinLarge - 1) + "px)"] = {
                    marginLeft: _isFooterInBody ? '0px' : panelMargin.sm,
                    marginRight: _isFooterInBody ? '0px' : panelMargin.sm
                },
                _a["@media (min-width: " + ScreenWidthMinSmall + "px) and (max-width: " + (ScreenWidthMinMedium - 1) + "px)"] = {
                    marginLeft: _isFooterInBody ? '0px' : panelMargin.xs,
                    marginRight: _isFooterInBody ? '0px' : panelMargin.xs
                },
                _a);
            break;
        case CoherencePanelSize.large:
            margins = (_b = {},
                _b["@media (min-width: " + ScreenWidthMinXLarge + "px)"] = {
                    marginLeft: _isFooterInBody ? '0px' : panelMargin.lg,
                    marginRight: _isFooterInBody ? '0px' : panelMargin.lg
                },
                _b["@media (min-width: " + ScreenWidthMinLarge + "px) and (max-width: " + (ScreenWidthMinXLarge - 1) + "px)"] = {
                    marginLeft: _isFooterInBody ? '0px' : panelMargin.md,
                    marginRight: _isFooterInBody ? '0px' : panelMargin.md
                },
                _b["@media (min-width: " + ScreenWidthMinMedium + "px) and (max-width: " + (ScreenWidthMinLarge - 1) + "px)"] = {
                    marginLeft: _isFooterInBody ? '0px' : panelMargin.sm,
                    marginRight: _isFooterInBody ? '0px' : panelMargin.sm
                },
                _b["@media (min-width: " + ScreenWidthMinSmall + "px) and (max-width: " + (ScreenWidthMinMedium - 1) + "px)"] = {
                    marginLeft: _isFooterInBody ? '0px' : panelMargin.xs,
                    marginRight: _isFooterInBody ? '0px' : panelMargin.xs
                },
                _b);
            break;
        case CoherencePanelSize.small:
        default:
            margins = (_c = {},
                _c["@media (min-width: " + ScreenWidthMinMedium + "px)"] = {
                    marginLeft: _isFooterInBody ? '0px' : panelMargin.sm,
                    marginRight: _isFooterInBody ? '0px' : panelMargin.sm
                },
                _c["@media (min-width: " + ScreenWidthMinSmall + "px) and (max-width: " + (ScreenWidthMinMedium - 1) + "px)"] = {
                    marginLeft: _isFooterInBody ? '0px' : panelMargin.xs,
                    marginRight: _isFooterInBody ? '0px' : panelMargin.xs
                },
                _c);
            break;
    }
    return margins;
};
export var isPanelHeightSufficient = function () {
    return window.innerHeight - 48 >= window.innerHeight * 0.85;
};
//# sourceMappingURL=StyleUtils.js.map